import Input from '@iui-kit/components/Input'
import BEM from '@iui-kit/utils/bem'
import { FormattedHTMLMessage } from 'react-intl'
import { ErrorMessage } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './InputLabel.css'

const bem = new BEM(styles)

const InputLabel = ({
  handleBlur,
  name,
  label,
  children,
  size,
  value,
  className,
  isValid,
  required,
  notRequired,
  showError,
  onChange,
  placeholder,
  autoFocus
}) => {
  return (
    <>
      <label
        className={bem
          .b('InputLabel')
          .m(`width-${size}`)
          .mix(className)
          .show()}
        htmlFor={name}
      >
        <span
          className={bem
            .b('InputLabel')
            .e('label')
            .show()}
        >
          <FormattedHTMLMessage id={label} />
          {required && (
            <sup
              className={bem
                .b('InputLabel')
                .e('mark')
                .show()}
            >
              *
            </sup>
          )}
          {notRequired && (
            <span
              className={bem
                .b('InputLabel')
                .e('not-required')
                .show()}
            >
              <FormattedHTMLMessage id="Brief.notRequired" />
            </span>
          )}
        </span>
        <Input
          className={bem
            .b('InputLabel')
            .e('input')
            .show()}
          value={value}
          id={name}
          name={name}
          valid={isValid}
          onChange={onChange}
          onBlur={handleBlur}
          autoFocus={autoFocus}
          placeholder={placeholder}
        />
        {showError && (
          <ErrorMessage
            className={bem
              .b('InputLabel')
              .e('error')
              .show()}
            component="span"
            name={name}
          />
        )}
      </label>
      {children && (
        <div
          className={bem
            .b('InputLabel')
            .e('footer')
            .show()}
        >
          {children}
        </div>
      )}
    </>
  )
}

InputLabel.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  size: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  children: PropTypes.instanceOf(Object),
  autoFocus: PropTypes.bool,
  isValid: PropTypes.bool,
  required: PropTypes.bool,
  notRequired: PropTypes.bool,
  showError: PropTypes.bool
}

InputLabel.defaultProps = {
  size: null,
  className: null,
  children: null,
  isValid: true,
  required: false,
  notRequired: false,
  showError: true
}

export default InputLabel
